import {
  Breakpoints,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { ChevronUp } from '@volkswagen-onehub/icons-core';
import { useCallback } from 'react';
import { useTribalContext } from '@/context/tribal';
import { StyledFooterBackToTopButton } from './FooterCTABackToTop.styles';

const FooterCTABackToTop = () => {
  const { contentManager } = useTribalContext();

  const handleScrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <StyledFooterBackToTopButton onClick={handleScrollToTop}>
      <span>
        <ChevronUp />
      </span>
      <Text
        tag={TextTag.span}
        appearance={
          TokenTextAppearance.copy200
        }
        bold
      >
        {contentManager.get('ctas-back-to-top')}
      </Text>
    </StyledFooterBackToTopButton>
  );
};

export default FooterCTABackToTop;
